/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import proptypes from 'prop-types';
import {
  IconButton,
  Drawer,
  DrawerHeader,
  DrawerBody,
  Typography,
  Accordion,
  AccordionHeader,
  AccordionBody
} from '@one-thd/sui-atomic-components';
import { Info } from '@one-thd/sui-icons';
import { getDrawerInfo } from '../../../utils/selectable-variant-utils';
import { InfoDrawerBody } from './InfoDrawerBody';

const { string, bool, arrayOf } = proptypes;

export const InfoDrawer = ({ variantNames = null, drawerHeader = null, isAccordion = false }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const drawerData = variantNames?.map((applType) => getDrawerInfo(applType));
  if (!drawerData?.length) {
    return null;
  }

  const drawerHeaderTitle = drawerHeader ?? drawerData[0]?.header;

  return (
    <>
      <IconButton
        icon={Info}
        iconSize="small"
        buttonSize="tight"
        aria-label="info-button"
        onClick={() => {
          setDrawerOpen(true);
        }}
      />

      <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)}>
        <DrawerHeader
          title={(
            <Typography variant="h4" height="none">{drawerHeaderTitle}</Typography>
          )}
          onClose={() => setDrawerOpen(false)}
        />
        <DrawerBody>
          {
            drawerData?.map((data, index) => {
              const { info, header, accordionHeader } = data;
              return isAccordion
                ? (
                  <Accordion key={`Accordion-${accordionHeader}-${index}`} noBorders>
                    <AccordionHeader>{accordionHeader}</AccordionHeader>
                    <AccordionBody>
                      <InfoDrawerBody
                        key={`info-drawer-body-${accordionHeader}-${index}`}
                        info={info}
                        isAccordion={isAccordion}
                      />
                    </AccordionBody>
                  </Accordion>
                )
                : <InfoDrawerBody key={`info-drawer-body-${header}-${index}`} info={info} />;
            })
          }
        </DrawerBody>
      </Drawer>
    </>
  );
};

InfoDrawer.propTypes = {
  variantNames: arrayOf(string),
  drawerHeader: string,
  isAccordion: bool
};
